import React, { PropsWithChildren } from 'react';
import { Stack } from '@mui/material';

interface Props {}

export const CalendarLayout = ({ children }: PropsWithChildren<Props>) => {
  return (
    <Stack height="100%" minHeight="600px" gap="1rem" sx={{ backgroundColor: 'white', padding: '0.5rem' }}>
      {children}
    </Stack>
  );
};
